export const convertEnvVarToBoolean = (value: string) => value && !/^(0|false|^$)$/.test(value);
